// ============================================================================
// FUNÇÕES DE FORMATAÇÃO
// ============================================================================

/**
 * Formata TP (Lead Time) em dias
 * Entrada: minutos
 * Saída: { value: número, unit: 'dias'|'h'|'min' }
 */
export const formatTP = (minutes: number): { value: string; unit: string } => {
  if (minutes === 0) return { value: '0', unit: 'min' };
  
  const days = minutes / (24 * 60);
  
  if (days >= 1) {
    return { value: days.toFixed(1), unit: 'dias' };
  }
  
  const hours = minutes / 60;
  if (hours >= 1) {
    return { value: hours.toFixed(1), unit: 'h' };
  }
  
  return { value: minutes.toFixed(0), unit: 'min' };
};

/**
 * Formata TRA (Cycle Time) em minutos ou horas
 * Entrada: minutos
 * Saída: { value: número, unit: 'h'|'min'|'seg' }
 */
export const formatTRA = (minutes: number): { value: string; unit: string } => {
  if (minutes === 0) return { value: '0', unit: 'min' };
  
  if (minutes >= 60) {
    return { value: (minutes / 60).toFixed(1), unit: 'h' };
  }
  
  if (minutes >= 1) {
    return { value: minutes.toFixed(1), unit: 'min' };
  }
  
  return { value: (minutes * 60).toFixed(0), unit: 'seg' };
};
